











































































import { Vue, Component, Prop, Mixins } from 'vue-property-decorator';
import { EvalSettingSimple } from '@/models/evalSetting/eval-setting-simple';
import { masterModule } from '@/store/modules/entities/master.module';
import { QuestionType } from '@/models/evalSetting/question-type';
import GExamListActionIcons from '@/views/GExamList/GExamListActionIcons.vue';
import GExamListStartTimeInput from '@/views/GExamList/GExamListStartTimeInput.vue';
import GExamListDeadlineInput from '@/views/GExamList/GExamListDeadlineInput.vue';
import GExamListTitleInput from '@/views/GExamList/GExamListTitleInput.vue';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';

@Component({
  name: 'GExamListCard',
  components: { GExamListTitleInput, GExamListStartTimeInput, GExamListDeadlineInput, GExamListActionIcons },
  computed: {},
  methods: {},
})
export default class GExamListCard extends Mixins(GPageBase) {
  @Prop() evalSettingSimple: EvalSettingSimple;

  mounted() {}

  get isRoleNormal(): boolean {
    return this.$store.state.account.isRoleNormal;
  }

  get isExamStatusEnd(): boolean {
    return this.evalSettingSimple.status === GEnum.ExamStatus.EndOfExamination;
  }

  questionSettingTypeTitle(questionSettingType: number): string {
    if (!masterModule.questionType(questionSettingType)) {
      return '';
    }
    return masterModule.questionType(questionSettingType).title;
  }
  questionType(questionSettingType: number): QuestionType {
    return masterModule.questionType(questionSettingType);
  }

  handleToEvalSettingDetail() {
    this.$emit('handleToEvalSettingDetail', this.evalSettingSimple.evalSettingID);
  }

  handleUpdateTitle(evalSettingSimple: EvalSettingSimple, beforeTitle: string) {
    this.$emit('handleUpdateTitle', evalSettingSimple, beforeTitle);
  }

  handleUpdateStartTime(evalSettingSimple: EvalSettingSimple, beforeStartTime: Date) {
    this.$emit('handleUpdateStartTime', evalSettingSimple, beforeStartTime);
  }

  handleUpdateDeadline(evalSettingSimple: EvalSettingSimple, beforeDeadline: Date) {
    this.$emit('handleUpdateDeadline', evalSettingSimple, beforeDeadline);
  }
}
